import {
  ICoreFactory,
  ICobranding,
  LinuxCobranding,
} from '@amzn/work-spaces-web-client-core-lib';
import { SoloCoreFactory } from './SoloCoreFactory';

export class LinuxCoreFactory extends SoloCoreFactory implements ICoreFactory {
  protected _cobranding?: ICobranding;
  getCobranding(): ICobranding {
    if (!this._cobranding) {
      this._cobranding = new LinuxCobranding(
        this.getLogger(),
        this.getMetrics(),
        this.getHttpClientWithFallback()
      );
    }
    return this._cobranding;
  }
}
